import { differenceInCalendarDays, set } from 'date-fns'

import { JUNE } from '../constants'
import { TIMEZONE } from './dateTimeUtil'
import _ from 'lodash'
import axios from '../axios/axios'
import { getTimezoneOffset } from 'date-fns-tz'

const DUMMY_SERVER_DATE = set(new Date(), {
  year: new Date().getFullYear(),
  month: JUNE,
  date: 26,
  hours: 12,
  minutes: 35,
})
const USE_DUMMY_SERVER_DATE = false

let serverTimeOffsetMs = 0
let serverTimeLoaded = false

const parseDateHeader = (value) => {
  if (_.isNil(value)) {
    return null
  }

  const parsed = new Date(value)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

export const isToday = (date) => {
  return differenceInCalendarDays(date, getServerDate()) === 0
}

export const isTomorrow = (date) => {
  return differenceInCalendarDays(date, getServerDate()) === 1
}

export const isYesterday = (date) => {
  return differenceInCalendarDays(date, getServerDate()) === -1
}

export const isFuture = (date) => {
  return date.getTime() > getServerDate().getTime()
}

export const isPast = (date) => {
  return date.getTime() < getServerDate().getTime()
}

const convertToServerTimezone = (date) => {
  const browserOffsetMs = -date.getTimezoneOffset() * 60000
  const targetOffsetMs = getTimezoneOffset(TIMEZONE, date)
  return new Date(date.getTime() + (targetOffsetMs - browserOffsetMs))
}

const localNow = () => (USE_DUMMY_SERVER_DATE ? DUMMY_SERVER_DATE.getTime() : Date.now())

export const getServerTimeOffsetMs = () => serverTimeOffsetMs
export const isServerTimeLoaded = () => serverTimeLoaded
export const getServerDate = () => convertToServerTimezone(new Date(localNow() + serverTimeOffsetMs))
export const getServerTimestamp = () => localNow() + serverTimeOffsetMs
export const getServerYear = () => getServerDate().getFullYear()

export const setServerTime = (serverDate) => {
  if (_.isString(serverDate)) {
    serverDate = new Date(serverDate)
  }
  if (!_.isDate(serverDate)) {
    return null
  }
  serverTimeOffsetMs = USE_DUMMY_SERVER_DATE ? 0 : serverDate.getTime() - localNow()
  serverTimeLoaded = true
  return serverDate
}

export const initServerTime = async () => {
  let serverDate = null
  try {
    const response = await axios.head('/', { noauth: true, validateStatus: () => true })
    if (response.headers?.date) {
      serverDate = parseDateHeader(response.headers.date)
    }
    if (!serverDate && response.status >= 400) {
      const fallback = await axios.head('/admin/message', { noauth: true, validateStatus: () => true })
      if (fallback.headers?.date) {
        serverDate = parseDateHeader(fallback.headers.date)
      }
    }
    if (serverDate) {
      console.info('Set time from server:', serverDate)
    }
  } catch (error) {
    console.error('Error fetching server time. Error:', error)
    serverDate = parseDateHeader(error?.response?.headers?.date)
  }

  if (!serverDate) {
    console.error("Error fetching server time, falling back to client's time. Error:")
    serverDate = new Date()
  }

  return setServerTime(serverDate)
}
